import {TextBlock as SubstanceTextBlock} from 'substance'

class ParagraphNode extends SubstanceTextBlock {}

ParagraphNode.type = 'paragraph'

export {ParagraphNode}
